// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mekpJf_PPUQ0XISm{margin-top:25px}.d0LZpveZFf0VMHMo{padding-left:25px;font-size:14px}.BhNSBVGgF_ANGjZW{margin-top:20px}.FZeQTAEQD0QwQqyq{padding:6px 3px;font-size:14px;border-bottom:1px solid var(--py-neutral-2)}.FZeQTAEQD0QwQqyq .gXGeUTKWHQ0tM0Zm{grid-gap:10px}ul li:hover label{color:var(--py-primary-4)}.v99wGCjvMbgiHuWz{margin-right:10px}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalCreateReviewButton": `mekpJf_PPUQ0XISm`,
	"modalHeader": `d0LZpveZFf0VMHMo`,
	"paginatorWrapper": `BhNSBVGgF_ANGjZW`,
	"templateRow": `FZeQTAEQD0QwQqyq`,
	"rowContent": `gXGeUTKWHQ0tM0Zm`,
	"radioButton": `v99wGCjvMbgiHuWz`
};
export default ___CSS_LOADER_EXPORT___;
